/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

// Ensure theme is applied on every route change (client-side navigation)
export const onRouteUpdate = () => {
  // Apply saved theme immediately on route change
  const savedTheme = localStorage.getItem('theme')
  if (savedTheme) {
    document.documentElement.setAttribute('data-theme', savedTheme)
  }
}

// Apply theme before initial client render
export const onClientEntry = () => {
  const savedTheme = localStorage.getItem('theme')
  if (savedTheme) {
    document.documentElement.setAttribute('data-theme', savedTheme)
  }
  // Mark theme as loaded
  document.documentElement.classList.remove('theme-loading')
  document.documentElement.classList.add('theme-loaded')
}
